export const appStates = {
    SIGNED_IN: 'SIGNED_IN_USER',
    SIGNED_OUT: 'SIGNED_OUT_USER',
    DESKTOP: 'DESKTOP_USER',
    MOBILE: 'MOBILE_USER'
};

export const mapModes = {
    DEFAULT: 'DEFAULT',
    DRAWING: 'DRAWING',
    MEASURE_TOOL: 'MEASURE_TOOL',
    MODIFYING: 'MODIFYING',
    AOI: 'AOI',
    FEATURE_SELECTED: 'FEATURE_SELECTED',
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    ADDING_OBSERVATION: 'ADDING_OBSERVATION'
};

export const drawStates = {
    ERROR: 'ERROR',
    VALID: 'VALID',
    INVALID: 'INVALID',
    EXCEEDS_EXTENT: 'EXCEEDS_EXTENT',
    OUTSIDE_SERVICE_AREA: 'OUTSIDE_SERVICE_AREA'
};

export const bookmarkTypes = {
    REQUEST: 'REQUEST',
    LOCATION: 'LOCATION'
};

export const mapMenuTabKeys = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    LAYERS: 'LAYERS',
    LEGEND: 'LEGEND',
    ENHANCED_MEASURES: 'ENHANCED_MEASURES',
    ISOLATED_VIEWS: 'ISOLATED_VIEWS',
    ASSET_OWNERS: 'ASSET_OWNERS',
    OBSERVATIONS: 'OBSERVATIONS',
    HELP: 'HELP',
    COVERAGE_ASSET_OWNERS: 'COVERAGE_ASSET_OWNERS'
};
